import React, { useState, useContext, useEffect } from "react";
import { Box, CardContent, Input, Button, Tooltip, TextField } from "@mui/material";

import { pageSourceService } from "../../../services/webServices.js";
import { useNavigate, useLocation } from "react-router-dom";
// import Locators from './Locators';  // Import the Locators component
import CommonAccordion from "../../custom-components/CommonAccordion.js";
import { validateUserInput, CagLocatorsGeneration, FrameworkBasedLocatorsGeneration } from "../../../services/webServices.js";
import { LoadingModalContext } from "../../main-pages/ServicePage.js";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import MessagePopup from "../../popup-components/MessagePopup.js";
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import CommonDownload from '../../custom-components/CommonDownload.js';
import { MenuItem } from "@mui/material";
import { Snackbar, Alert } from "@mui/material";



// import LocatorsTable from '../test-automation/LocatorsTable';
import CagLocatorsTable from './CagLocatorTable.js';


const validatePageSource = (pageSource) => {
  if (!pageSource || typeof pageSource !== "string") {
    return "Invalid input: Page source must be a string.";
  }

  const trimmedSource = pageSource.trim();
  if (!trimmedSource.startsWith("<") || !trimmedSource.endsWith(">")) {
    return "Invalid Page Source: Must start with '<' and end with '>'.";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(trimmedSource, "text/html");
  const parserErrors = doc.querySelectorAll("parsererror");

  if (parserErrors.length > 0) {
    return "Invalid HTML Structure: Parsing failed. Please check your tags and structure.";
  }

  if (!doc.querySelector("html") || !doc.querySelector("body")) {
    return "Page source is missing <html> or <body> tags.";
  }

  return null; // Valid
};

const CagLocatorsGenerationComp = () => {
  const [pageSourceInput, setPageSourceInput] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoadingState } = useContext(LoadingModalContext);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [sessionExpiredValue, setSessionExpiredValue] = useState(false);
  const [generatedLocators, setgeneratedLocators] = useState([]);
  const defaultFeatureFilesExpanded =
    true && !Object.keys(generatedLocators).length > 0;
  const [showSecondAccordion, setShowSecondAccordion] = useState(false);
  const [modifiedLocators, setmodifiedLocators] = useState({});
  const [activeThumb, setActiveThumb] = useState(null);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const defaultLocatorsExpanded = true && Object.keys(generatedLocators).length > 0;
  const [extraInput, setExtraInput] = useState("");
  const [selectorEngine, setSelectorEngine] = useState("");
  const [showSemanticCode, setShowSemanticCode] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);


  const validatePageSource = (pageSource, selectorEngine) => {
  if (!pageSource || typeof pageSource !== "string") {
    return "Invalid input: Page source must be a string.";
  }

  const trimmed = pageSource.trim();

  // Semantic mode uses JSON input
  if (selectorEngine === "Semantic Intelligence Locators (Playwright, Testing Library)") {
    try {
      const parsed = JSON.parse(trimmed);
      if (!Array.isArray(parsed) && typeof parsed !== "object") {
        return "Invalid Semantic JSON: Must be an array or object of elements.";
      }
      return null; 
    } catch {
      return "Invalid JSON format for semantic locator generation.";
    }
  }

  return null;
};

  const handleUserStoryChange = (e) => {
    setPageSourceInput(e.target.value);
  };
  //   useEffect(()=>{
  //      console.log("callingggggggggg");

  //   },[])

  const handleGenerateLocators = async () => {
    const validationError = validatePageSource(pageSourceInput);
    if (validationError) {
      setPopupMessage(validationError);
      setPopupOpen(true);
      return;
    }
    // setPageSource(pageSourceInput);
    let fake;

    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;

      const interval = setInterval(() => {
        if (stop) return;

        progress += 0.4;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }

        if (progress >= 97) progress = 97;

        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);

      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Generating Locators",
      progress: 0,
    });

    fake = startProgress(setLoadingState);
    try {
      // AI-based input validation before generation
      // const aiValidationResponse = await validateUserInput({
      //   pageSource: pageSourceInput,
      //   promptType: "pageSource",
      // });

      // if (aiValidationResponse?.data?.Result?.toLowerCase() !== "clean") {
      //   const errorMsg =
      //     aiValidationResponse?.data?.Reason ||
      //     "Inappropriate content detected in page source. Please revise and try again.";
      //   setPopupMessage(errorMsg);
      //   setPopupOpen(true);
      //   return;
      // }

      // const requestData = { pageSource: pageSourceInput };
      // const requestData = selectorEngine
      //   ? { pageSource: pageSourceInput, selectorEngine }
      //   : { pageSource: pageSourceInput };
      // const generatedLocatorsResponse = await CagLocatorsGeneration(requestData);
      // const generatedLocators = generatedLocatorsResponse.data.data;
      let generatedLocatorsResponse;

      if (selectorEngine) {
        // Call new backend
        generatedLocatorsResponse = await FrameworkBasedLocatorsGeneration({
          pageSource: pageSourceInput,
          selectorEngine
        });
      } else {
        // Call old backend
        generatedLocatorsResponse = await CagLocatorsGeneration({
          pageSource: pageSourceInput
        });
      }

      const generatedLocators = generatedLocatorsResponse.data.data;

      await finishTo100AndClose();
      console.log(generatedLocators, "generatedLocators");
      const result = generatedLocators.reduce((acc, item) => {
        const output = item.output;

        if (output && typeof output === "object") {
          for (const key in output) {
            if (output.hasOwnProperty(key)) {
              acc[key] = output[key];
            }
          }
        }
        return acc;
      }, {});
      console.log(result, "resultresult");
      setmodifiedLocators(result)
      setgeneratedLocators(generatedLocators);
      setShowSecondAccordion(true);
      console.log(generatedLocators, "generatedLocatorsgeneratedLocatorsgeneratedLocators");

      if (
        !generatedLocators ||
        typeof generatedLocators !== "object" ||
        Object.keys(generatedLocators).length === 0
      ) {
        setPopupMessage("Locators generation failed. Please provide proper page source.");
        setPopupOpen(true);
        return;
      }

      // navigate(location.pathname, {
      //   state: {
      //     ...location.state,
      //     pageSource: pageSourceInput,
      //     generatedLocators: generatedLocators,
      //   },
      //   replace: true,
      // });
    } catch (error) {
      console.error("Error generating locators:", error);
      const errorMsg =
        error?.response?.data?.Error ||
        error?.response?.data?.message ||
        "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (errorMsg === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
      setLoadingState({ open: false, message: "", progress: null });

    } finally {
      setLoadingState({ open: false, message: "", progress: null });
    }
  };

  const handleThumbClick = (thumbType) => {
    // Toggle thumbs based on the thumbType (like or dislike)
    setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
  };
  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };

  const navigateToTestAutomation = () => {
    navigate(`/dashboard/test-automation`)
   };


  const continuewithnextDOM = () => {
    window.location.reload()
    // navigate(`/dashboard/cag-locators/cag-locators-generation`)
   };

  const semanticHelperCode = `function getXPath(el) {
  if (el.id) return \`//*[@id="\${el.id}"]\`;
  if (el === document.body) return "/html/body";

  let idx = 0;
  const siblings = el.parentNode ? [...el.parentNode.children] : [];

  for (let sib of siblings) {
    if (sib.tagName === el.tagName) idx++;
    if (sib === el) {
      return \`\${getXPath(el.parentNode)}/\${el.tagName.toLowerCase()}[\${idx}]\`;
    }
  }
  return "";
}

function getCssSelector(el) {
  if (el.id) return \`#\${el.id}\`;

  let selector = el.tagName.toLowerCase();

  let className = "";
  if (typeof el.className === "string") {
    className = el.className;
  } else if (typeof el.className?.baseVal === "string") {
    className = el.className.baseVal;     // SVG support
  }

  if (className) {
    const cls = className.trim().split(/\\s+/).slice(0, 2).join(".");
    if (cls) selector += \`.\${cls}\`;
  }

  return selector;
}

const VALID_TAGS = new Set([
  "button", "input", "select", "textarea", "label", "a", "img"
]);

function isImportant(el) {
  return (
    VALID_TAGS.has(el.tagName.toLowerCase()) ||
    el.getAttribute("role") ||
    el.getAttribute("aria-label") ||
    el.getAttribute("placeholder") ||
    el.getAttribute("alt") ||
    el.getAttribute("title") ||
    el.getAttribute("data-testid") ||
    el.getAttribute("data-test")
  );
}

function getSmartText(el) {
  let txt =
    el.innerText?.trim() ||
    el.textContent?.trim() ||
    el.value?.trim() ||
    null;

  if (txt && txt.length > 80) {
    txt = txt.slice(0, 80);
  }
  return txt || null;
}

const elements = [...document.querySelectorAll("*")]
  .filter(isImportant)
  .map(el => {
    return {
      tag: el.tagName.toLowerCase(),
      id: el.id || null,
      name: el.name || null,

      role: el.getAttribute("role") || null,
      ariaLabel: el.getAttribute("aria-label") || null,
      placeholder: el.getAttribute("placeholder") || null,
      text: getSmartText(el),
      alt: el.getAttribute("alt") || null,
      title: el.getAttribute("title") || null,
      testId:
        el.getAttribute("data-testid") ||
        el.getAttribute("data-test") ||
        null,

      css: getCssSelector(el),
      xpath: getXPath(el)
    };
  });

console.log(JSON.stringify(elements, null, 2));`;


  const buttonsgroup = [
    {
      label: 'Download',
      onClick: handleDownloadClick,
      variant: 'text',
      startIcon: <SaveAltRoundedIcon />,
      // sx: { textTransform: 'none' } 
      size: "small",
      sx: { textTransform: 'none', px: 1, py: 0.5, fontSize: "0.85rem" }
    },
    {
      label: "Test automation landing page",
      variant: "contained",
      onClick: navigateToTestAutomation,
      size: "small",
      sx: { px: 1.5, py: 0.5, fontSize: "0.85rem" }
    },
    {
      label: "Continue with next DOM",
      variant: "contained",
      onClick: continuewithnextDOM,
      size: "small",
      sx: { px: 1.5, py: 0.5, fontSize: "0.85rem" }
    }
  ]


  const handleCloseDownload = () => {
    setDownloadOpen(false);
  };

  const tableDataConverter = (locators) => {
    if (
      !locators ||
      typeof locators !== "object" ||
      Object.keys(locators).length === 0 ||
      !Object.values(locators)[0]
    ) {
      return { headers: [], values: [] };
    }
    const headers = ["Parameters", ...(Object.keys(Object.values(locators)[0]))];
    const values = [];
    Object.entries(locators).map(([parameter, locatorValues]) => {
      const eachRow = [parameter, ...Object.values(locatorValues)];
      values.push(eachRow);
    })
    return { headers, values };
  }



  return (
    <Box sx={{ maxWidth: 600, margin: "auto" }}>
      <CommonAccordion
        type={"output"}
        summary={"Page Source"}
        details={
          <>
            <Box sx={{ color: "#2b2f30", marginBottom: 2 }}>
              Include only relevant DOM elements to avoid inaccurate locators
              and unnecessary automation complexity.
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                // alignItems: 'center',
                // width: '100%',
                // marginTop: '50px',
              }}
            >
              {/* <form>
                <TextField
                  label="Enter Document name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  autoComplete="off"
                  value={extraInput}
                  onChange={(e) => setExtraInput(e.target.value)}
                /> */}
                <form>
                <TextField
                  label="Enter Document name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  autoComplete="off"
                  value={extraInput}
                  onChange={(e) => setExtraInput(e.target.value)}
                />

                {/* DROPDOWN */}
                <TextField
                  select
                  label="Selector Engine"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={selectorEngine}
                  onChange={(e) => setSelectorEngine(e.target.value)}
                  autoComplete="off"
                >
                  <MenuItem value="classic">
                    Classic Selector Engines (Selenium, WebdriverIO, Robot Framework, Protractor)
                  </MenuItem>

                  <MenuItem value="dom-centric">
                    DOM-Centric Selector Runners (Cypress, TestCafe, Puppeteer)
                  </MenuItem>

                  <MenuItem value="semantic">
                    Semantic Intelligence Locators (Playwright, Testing Library)
                  </MenuItem>
                </TextField>
                {/* {selectorEngine === "semantic" && (
                  <Box
                    sx={{
                      bgcolor: "#f7f7f7",
                      border: "1px solid #ccc",
                      borderRadius: 2,
                      p: 2,
                      mt: 2,
                      fontSize: "0.85rem",
                      overflowX: "auto"
                    }}
                  >
                    <Box sx={{ fontWeight: 600, mb: 1, color: "#333" }}>
                      Run this code in browser console before placing Page Source ↓
                    </Box>

                    <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                      {semanticHelperCode}
                    </pre>

                    <Button
                      variant="outlined"
                      size="small"
                      sx={{ mt: 1, textTransform: "none" }}
                      onClick={() => navigator.clipboard.writeText(semanticHelperCode)}
                    >
                      Copy Code
                    </Button>
                  </Box>
                )} */}
{selectorEngine === "semantic" && (
  <Box
    sx={{
      mt: 2,
      mb: 3,
      p: 2,
      borderRadius: 2,
      bgcolor: "#f8fafc",
      border: "1px solid #e2e8f0",
    }}
  >
    <Box
      sx={{
        fontSize: "0.9rem",
        fontWeight: 600,
        mb: 1,
        color: "#1e293b",
      }}
    >
      Semantic Processing Required
    </Box>

    <Box sx={{ fontSize: "0.8rem", mb: 1.5, color: "#475569" }}>
      Run the preprocessing script in DevTools(Ctrl+Shift+i) → Click Console → Paste The Code → Copy the Generated Output → paste into
      “Page Source”.
    </Box>

      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          variant="text"
          size="small"
          sx={{ textTransform: "none" }}
          onClick={() => setShowSemanticCode(prev => !prev)}
        >
          {showSemanticCode ? "Hide Code" : "Expand to view code"}
        </Button>
        <Button
        variant="outlined"
        size="small"
        sx={{
          textTransform: "none",
          borderRadius: 2,
          px: 1.5,
          py: 0.6,
          fontSize: "0.8rem",
        }}
        onClick={() => {
          navigator.clipboard.writeText(semanticHelperCode);
          setCopySuccess(true);
        }}
      >
        Copy Script
      </Button>
      </Box>

      {showSemanticCode && (
        <Box
          sx={{
            mt: 2,
            p: 2,
            borderRadius: 2,
            bgcolor: "#fff",
            border: "1px solid #e2e8f0",
            maxHeight: 300,
            overflowY: "auto",
          }}
        >
          <pre style={{ whiteSpace: "pre-wrap", fontSize: "0.75rem" }}>
            {semanticHelperCode}
          </pre>

          <Button
            variant="outlined"
            size="small"
            sx={{ textTransform: "none", mt: 1 }}
            onClick={() => {
              navigator.clipboard.writeText(semanticHelperCode);
              setCopySuccess(true);
            }}
          >
            Copy Code
          </Button>
        </Box>
      )}
    </Box>
  )}



                <CardContent
                  sx={{
                    // padding: 1,
                    width: 500,
                    bgcolor: "#E4E3E3",
                    borderRadius: 2,
                    marginBottom: 6,
                    // boxShadow: 3,
                  }}
                >
                  <Input
                    fullWidth
                    disableUnderline
                    multiline
                    minRows={5}
                    maxRows={10}
                    margin="normal"
                    placeholder="Enter Page Source"
                    value={pageSourceInput}
                    onChange={handleUserStoryChange}
                    autoComplete="off"
                    sx={{
                      color: "black",
                      bgcolor: "transparent",
                      padding: "10px 10px 10px 33px",
                    }}
                  />
                  <hr style={{ borderColor: "rgba(0, 0, 0, 0.12)" }} />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      mt: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      startIcon={<GenerateButton />}
                      sx={{
                        mt: 0,
                        textTransform: "none",
                        backgroundColor: "#49A3FF",
                      }}
                      disabled={!(pageSourceInput.trim() && extraInput)}
                      onClick={handleGenerateLocators} // Handle Generate Locators button click
                    >
                      Generate Locators
                    </Button>
                  </Box>
                </CardContent>
              </form>

              {/* Conditionally render the Locators accordion after the "Generate Locators" button is clicked */}
            </Box>
          </>
        }
        defaultExpanded={defaultFeatureFilesExpanded}
      />
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />
      {
      showSecondAccordion &&
        <CommonAccordion
          summary={"Locators"}
          details={
            <Box>
              <CagLocatorsTable jsonData={modifiedLocators} setJsonData={setmodifiedLocators} />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, marginTop: 2 }}>
                <Tooltip title="Like" arrow>
                  <Box
                    onClick={() => handleThumbClick("like")}
                    sx={{
                      cursor: "pointer",
                      marginRight: 2, // Margin between the buttons
                      "&:hover": {
                        color: "#49A3FF", // Change color on hover
                      },
                    }}
                  >
                    {activeThumb === "like" ? (
                      <ThumbUpIcon sx={{ fontSize: "24px" }} /> // Filled thumbs up when clicked
                    ) : (
                      <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs up by default
                    )}
                  </Box>
                </Tooltip>

                {/* Thumbs Down Button with Tooltip */}
                <Tooltip title="Dislike" arrow>
                  <Box
                    onClick={() => handleThumbClick("dislike")}
                    sx={{
                      cursor: "pointer",
                      marginRight: 2, // Margin between the buttons
                      "&:hover": {
                        color: "#FF4842", // Change color on hover
                      },
                    }}
                  >
                    {activeThumb === "dislike" ? (
                      <ThumbDownIcon sx={{ fontSize: "24px" }} /> // Filled thumbs down when clicked
                    ) : (
                      <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs down by default
                    )}
                  </Box>
                </Tooltip>
              </Box>
            </Box>
          }
          buttons={buttonsgroup}
          fullScreenMode={true}
          type={"output"}
          defaultExpanded={defaultLocatorsExpanded}
        />
      }
      <CommonDownload
        open={downloadOpen}
        onClose={handleCloseDownload}
        serviceResponse={
          [
            {
              heading: "Locators",
              type: "table",
              data: {
                ...tableDataConverter(modifiedLocators)
              }
            }
          ]
        }
        serviceName={extraInput}
        wordData={[{ heading: "Locators", type: "table", data: { ...tableDataConverter(modifiedLocators) } }]}
        documents={['pdf', 'docx']}
      />
      <Snackbar
        open={copySuccess}
        autoHideDuration={2000}
        onClose={() => setCopySuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setCopySuccess(false)}
          severity="success"
          variant="filled"
          sx={{
            bgcolor: "#49A3FF",      // primary brand blue
            color: "#fff",
            fontSize: "0.9rem",
            borderRadius: "8px",
            boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
            px: 2,
            py: 1,
            textTransform: "none",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          Copied to clipboard!
        </Alert>
      </Snackbar>

    </Box>
  );
};

export default CagLocatorsGenerationComp;
